import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { requireAuth } from "~/lib/auth-guard";
import { orpc } from "~/lib/orpc-client";
import { Skeleton } from "@alchema/ui";
import * as m from "~/paraglide/messages";
import { PillTabs } from "~/components/shared/PillTabs";

export const Route = createFileRoute("/salary")({
  beforeLoad: async () => { await requireAuth(); },
  component: SalaryLayout,
  pendingComponent: SalaryLayoutSkeleton,
});

function SalaryLayoutSkeleton() {
  return (
    <div className="mx-auto max-w-4xl p-8">
      <Skeleton className="h-8 w-48" />
      <div className="mt-6 space-y-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-20 rounded-xl" />
        ))}
      </div>
    </div>
  );
}

const TABS = [
  { to: "/salary", label: m.salary_tab_benchmarks() },
  { to: "/salary/negotiate", label: m.salary_tab_negotiate() },
];

function SalaryLayout() {
  const tierQuery = useQuery({
    ...orpc.billing.currentTier.queryOptions(),
    retry: 0,
  });

  if (tierQuery.isLoading) {
    return <SalaryLayoutSkeleton />;
  }

  const tier = tierQuery.data;
  const isPremium = tier && tier.tier !== "free";

  if (!isPremium) {
    return (
      <div className="mx-auto max-w-4xl p-8 animate-fade-up">
        <h1
          className="font-semibold tracking-tight"
          style={{ fontSize: 22, fontFamily: "var(--font-display)", color: "var(--text)" }}
        >
          {m.salary_title()}
        </h1>
        <div
          className="mt-8 rounded-xl p-8 text-center"
          style={{ border: "1px solid var(--border-subtle)", background: "var(--surface)" }}
        >
          <div className="mx-auto max-w-md">
            <h2 className="text-lg font-semibold" style={{ color: "var(--text)" }}>
              {m.salary_upgrade_title()}
            </h2>
            <p className="mt-2 text-sm" style={{ color: "var(--text-muted)" }}>
              {m.salary_upgrade_desc()}
            </p>
            <Link
              to="/settings"
              className="mt-6 inline-block rounded-lg px-6 py-2.5 text-sm font-medium hover:opacity-90 transition-opacity"
              style={{ background: "var(--accent)", color: "#fff" }}
            >
              {m.salary_upgrade_cta()}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl p-8 animate-fade-up">
      <h1
        className="font-semibold tracking-tight"
        style={{ fontSize: 22, fontFamily: "var(--font-display)", color: "var(--text)" }}
      >
        {m.salary_title()}
      </h1>

      <div className="mt-6">
        <PillTabs tabs={TABS} />
        <Outlet />
      </div>
    </div>
  );
}
